import { Link } from "react-router-dom";

const ValouseVoyageParcours = () => {
  return (
    <div className="min-h-screen bg-[#3F2A24] text-[#F3E5CF]">
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
        {/* Back to Valouse */}
        <div className="mb-6">
          <Link
            to="/valouse"
            className="inline-flex items-center gap-2 text-sm text-[#E8D2B5] hover:text-[#F3E5CF] transition-colors"
          >
            <span>← Retour à COCON Valouse</span>
          </Link>
        </div>

        <header className="text-center space-y-3">
          <h1 className="font-serif text-3xl md:text-4xl">Avant · Cœur · Après</h1>
        </header>

        <section className="space-y-8 text-sm leading-relaxed">
          {/* Bloc 1 — Le Lien Avant */}
          <article className="px-6 py-8 rounded-3xl bg-[#6B4A3B] text-center text-[#F3E5CF] space-y-4 border border-[#E8D2B5]/40">
            <p className="text-sm tracking-[0.35em] uppercase text-[#F3E5CF]">
              — Le Lien Avant —
            </p>
            <p className="font-serif text-lg">Pré-COCON</p>
            <p>
              Avant même d’arriver à Valouse,
              <br />
              le <span className="italic uppercase">COCON</span> commence à se tisser.
            </p>
            <p>
              Cette phase est un temps de préparation consciente.
              <br />
              Un espace pour ralentir avant le départ,
              <br />
              se relier au groupe,
              <br />
              et commencer à quitter la tête
              <br />
              pour revenir au corps et au ressenti.
            </p>
            <p>
              Un temps pour déposer ce qui est là,
              <br />
              poser des intentions simples,
              <br />
              et entrer dans le voyage avec plus de présence
              <br />
              et de disponibilité intérieure.
            </p>
            <p>
              Ce lien avant la retraite permet aux âmes qui le souhaitent
              <br />
              de ne pas arriver “à froid”,
              <br />
              mais déjà reliées à l’esprit du <span className="italic uppercase">COCON</span>,
              <br />
              au rythme,
              <br />
              et au cercle.
            </p>
            <p>
              Il ne s’agit pas de se préparer “comme il faut”.
              <br />
              Il s’agit simplement
              <br />
              d’ouvrir l’espace intérieur
              <br />
              avant la traversée.
            </p>
          </article>

          {/* Bloc 2 — Le Cœur du Voyage */}
          <article className="px-6 py-8 rounded-3xl bg-[#F3E5CF] text-center text-[#3F2A24] space-y-4 border border-[#E8D2B5]/40">
            <p className="text-sm tracking-[0.35em] uppercase text-[#3F2A24]">
              — Le Cœur du Voyage —
            </p>
            <p className="font-serif text-lg">
              <span className="italic uppercase">COCON</span> · Valouse · Drôme Provençale
            </p>
            <p>
              Le cœur du <span className="italic uppercase">COCON</span> se vit à Valouse.
              <br />
              Un hameau préservé, niché en Drôme provençale,
              <br />
              habituellement fermé au public.
            </p>
            <p>
              Un lieu rare,
              <br />
              réservé longtemps à l’avance,
              <br />
              qui devient, le temps de la retraite,
              <br />
              un sanctuaire temporaire.
            </p>
            <p>
              Ici, le rythme change.
              <br />
              Le silence soutient.
              <br />
              La nature accompagne.
            </p>
            <p>
              Le cercle est volontairement limité
              <br />
              à trente âmes au maximum.
            </p>
            <p>
              Pas un événement.
              <br />
              Pas une foule.
            </p>
            <p>
              Un groupe à taille humaine.
              <br />
              Une vie partagée.
              <br />
              Des temps communs,
              <br />
              des respirations,
              <br />
              des silences.
            </p>
            <p>
              Tout au long du séjour,
              <br />
              tu es accompagné·e par une équipe de femmes-médecines,
              <br />
              aux approches complémentaires et incarnées.
            </p>
            <p>
              Elles ne guident pas depuis un piédestal.
              <br />
              Elles vivent le <span className="italic uppercase">COCON</span> avec toi.
              <br />
              Les repas.
              <br />
              Le quotidien.
              <br />
              Les cercles.
              <br />
              Les silences.
              <br />
              Les passages plus sensibles, s’ils se présentent.
            </p>
            <p>
              <span className="italic uppercase">COCON</span> est un cercle vivant.
              <br />
              Un espace où les masques peuvent tomber,
              <br />
              doucement.
            </p>
            <p>
              On y rit.
              <br />
              On y pleure parfois.
              <br />
              On y respire ensemble.
            </p>
            <p>
              Le lien ne s’arrête pas au dernier jour.
              <br />
              Il continue, autrement.
              <br />
              À son rythme.
            </p>
          </article>

          {/* Bloc 3 — L’Intégration */}
          <article className="px-6 py-8 card-sacred text-center text-[#3F2A24] space-y-4">
            <p className="text-sm tracking-[0.35em] uppercase text-[#3F2A24]">
              — L’Intégration —
            </p>
            <p className="font-serif text-lg">
              Post-<span className="italic uppercase">COCON</span>
            </p>
            <p>
              Après la retraite,
              <br />
              le voyage ne s’arrête pas.
            </p>
            <p>
              Cette phase est un temps d’intégration.
              <br />
              Un espace pour revenir à ce qui a été ouvert,
              <br />
              laisser infuser,
              <br />
              et ancrer dans la matière
              <br />
              ce qui a été traversé.
            </p>
            <p>
              Un temps pour relire le vécu,
              <br />
              se soutenir,
              <br />
              et laisser les transformations s’installer
              <br />
              dans le quotidien.
            </p>
            <p>
              Repartir plus stable,
              <br />
              plus alignée,
              <br />
              plus confiante.
            </p>
            <p>
              Non pas “transformée” de l’extérieur,
              <br />
              mais profondément reliée
              <br />
              à sa vérité intérieure.
            </p>
            <p>
              Le <span className="italic uppercase">COCON</span> continue d’accompagner
              <br />
              ce qui est en train de devenir.
            </p>
          </article>
        </section>
      </div>
    </div>
  );
};

export default ValouseVoyageParcours;
